module.exports = __webpack_public_path__ + "img/Female-Gamer-Background.png";